import { api } from './api'

export const fetchBranch = (query) => api.get('/branch', query)
export const syncBranch = () => api.post('/branch/sync')
